import React from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';

// const trackingId = "UA-1833250-11";
ReactGA.initialize([{
    trackingId: "G-7CXZGRQL39",
},
{
trackingId: "your second GA measurement id",
}]);

class GoogleAnalytics extends React.Component {


    componentDidUpdate ({ location, history }) {

        // const gtag = window.gtag;

        if (location.pathname === this.props.location.pathname) {
            // console.log(" don't log identical link clicks (nav links likely)");
            // don't log identical link clicks (nav links likely)
            return;
        }

        // console.log("history.action:", history.action);
        
        if (history.action === 'PUSH') {
            // gtag('config', 'UA-1833250-11', {
            //     'page_title': document.title,
            //     'page_location': window.location.href,
            //     'page_path': location.pathname
            // });
            // ga('send', 'pageview', 'window.location.href',
            //     {
            //         'title': document.title,
            //         'location': window.location.href,
            //         'path': location.pathname
            //     }
            // );
            // ReactGA.pageview(window.location.pathname + window.location.search);
            ReactGA.send({ 
                hitType: "pageview", 
                page: window.location.pathname + window.location.search, 
                // title: "Custom Title" 
            });

        }
    }

    componentDidMount () {
        // if (typeof(ga) === 'function') {
            // console.log('componentDidMount sending view');
            // ReactGA.pageview(window.location.pathname + window.location.search);
            ReactGA.send({ 
                hitType: "pageview", 
                page: window.location.pathname + window.location.search, 
                // title: "Custom Title" 
            });
        // }
    }

    render () {
        return null;
    }
}

export default withRouter(GoogleAnalytics);